import React, { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/utils";

type FieldProps = React.ComponentProps<"input"> & {
  label: string;
  labelHtmlFor: string;
  error?: boolean;
};

const Field = forwardRef<HTMLInputElement, FieldProps>(
  ({ label, labelHtmlFor, type, className, ...props }, ref) => {
    const isPassword = type === "password";
    const [visible, setVisible] = useState(false);
    const effectiveType = isPassword ? (visible ? "text" : "password") : type;

    return (
      <div className="space-y-2">
        <Label htmlFor={labelHtmlFor}>{label}</Label>
        <div className="relative">
          <Input
            ref={ref}
            type={effectiveType}
            className={cn(isPassword && "pr-10", className)}
            {...props}
          />
          {isPassword && (
            <button
              type="button"
              onClick={() => setVisible((v) => !v)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-startfly-gray hover:text-startfly-black focus-visible:outline-none"
              aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
              aria-pressed={visible}
            >
              {visible ? (
                <EyeOff className="h-4 w-4" />
              ) : (
                <Eye className="h-4 w-4" />
              )}
            </button>
          )}
        </div>
      </div>
    );
  }
);

Field.displayName = "Field";

export default Field;
